import { useEffect, useState } from "react";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../../components/commons";
import { RootState } from "../../../redux/rootReducers";
import toast, { Toaster } from "react-hot-toast";
import { connect } from "react-redux";
import { resetSession } from "../../../redux/auth";
import {
  createMasterEmailersAction,
  getMasterDataEmailersAction,
  resetEmailListTotalCount,
  resetEmailerList,
  resetMasterError,
  resetMasterMessage,
  resetMasterStatusCode,
  resetMasterSuccess,
  updateMasterDataEmailersAction,
} from "../../../redux/masterData";

import { SearchIcon } from "../../../components/Icon";
import { EmptyList } from "../../../assets/images";
import useDebounce from "../../../customHooks/useDebounce";
import EmailersTable from "../../../components/MasterData/EmailersTable/EmailersTable";
import AddEditEmailers from "./AddEditEmailers";
import { CreateEmailersDataPayloadType, GetEmailerDataPayloadType, UpdateEmailerDataPayloadType } from "../../../commonTypes/masterDataTypes";
import { MasterEmailerList } from "../../../redux/masterData/masterTypes";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";

type AppProps = {
  history: any;
  fetching: boolean;
  message: string;
  success: null | number;
  error: null | string;
  statusCode: null | number;
  isOpen: boolean;
  branchHeaders: [];
  token: null | string;
  emailerList: MasterEmailerList[]|[];
  emailListTotalCount: number;
  dispatchResetMasterStatusCode: () => void;
  dispatchResetSession: () => void;
  dispatchResetMasterDataEmailerListing: () => void;
  dispatchResetMasterDataEmailerListTotal: () => void;
  dispatchResetMasterSuccess: () => void;
  dispatchResetMasterMessage: () => void;
  dispatchResetMasterError: () => void;
  dispatchUpdateMasterDataEmailers: (data: UpdateEmailerDataPayloadType) => void;
  dispatchAddMasterEmailers: (data: CreateEmailersDataPayloadType) => void;
  dispatchGetMasterDataEmailers: (data: GetEmailerDataPayloadType) => void;
};
const Email = ({
  fetching,
  message,
  success,
  error,
  token,
  statusCode,
  dispatchResetMasterError,
  dispatchResetMasterDataEmailerListing,
  dispatchResetSession,
  dispatchResetMasterDataEmailerListTotal,
  dispatchResetMasterSuccess,
  dispatchResetMasterMessage,
  dispatchResetMasterStatusCode,
  dispatchGetMasterDataEmailers,
  dispatchUpdateMasterDataEmailers,
  dispatchAddMasterEmailers,
  emailerList,
  emailListTotalCount,
}: AppProps) => {
  const [showAddEditEmailerModal, setShowAddEditEmailerModal] =
    useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [emailerNameError, setEmailerNameError] = useState<string>("");
  const [emailerName, setEmailerName] = useState<string>("");
  const [subject, setSubject] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [searchValue, setSearchValue] = useState("");
  const [data, setData] = useState< MasterEmailerList[]|[]>([]);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [id, setId] = useState<string | null | undefined>(null);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [status , setStatus ]= useState<boolean>()

    //====================User Management=============================
    const [isAddEmailPresent, setIsAddEmailPresent] =
    useMenuCheck();
    const [isUpdateEmailPresent, setIsUpdateEmailPresent] =
    useMenuCheck();
 
  //=================================================================

  useEffect(() => {
    dispatchResetMasterSuccess();
    dispatchResetMasterError();
    dispatchResetMasterMessage();
    dispatchResetMasterDataEmailerListing();
    dispatchResetMasterDataEmailerListTotal();
    dispatchResetMasterStatusCode();
    setIsAddEmailPresent("Add Email", "menu")
    setIsUpdateEmailPresent("Update Email", "menu")
  }, []);

  useEffect(() => {
    if (emailerList?.length === 0) {
      setData(emailerList);
    }
    if (offset > 0) {
      setData((prv: any) => [...prv, ...emailerList]);
    } else {
      setData(emailerList);
    }
  }, [emailerList]);

  useEffect(() => {
    if (token) {
      let finalData: GetEmailerDataPayloadType = {
        token,
        limit,
        offset,
        searchValue,
      };
      if (emailListTotalCount) {
        if (offset < emailListTotalCount) {
          dispatchGetMasterDataEmailers(finalData);
        }
      } else {
        dispatchGetMasterDataEmailers(finalData);
      }
    }
  }, [offset]);

  useDebounce(
    () => {
      if (searchValue) {
        fetchNewData();
      } else {
        let finalData: GetEmailerDataPayloadType = {
          token,
          limit,
          offset,
          searchValue,
        };
        dispatchGetMasterDataEmailers(finalData);
      }
    },
    500,
    [searchValue]
  );

  useEffect(() => {
    if (!showAddEditEmailerModal) {
      setIsEdit(false);
    }
  }, [showAddEditEmailerModal]);

  const handleEmailerNameChange = (e: any) => {
    setEmailerName(e.target.value);
  };
  const handleSubjectChange = (e: any) => {
    setSubject(e.target.value);
  };
  const handleDescriptionChange = (e: any) => {
    setDescription(e.target.value);
  };
  const toggleAddEditEmailerModal = () => {
    if (!showAddEditEmailerModal) {
      handleResetData();
    }

    setShowAddEditEmailerModal(!showAddEditEmailerModal);
  };

  const handleResetData = () => {
    setEmailerName("");
    setSubject("");
    setDescription("");
    setOffset(0);
  };

  const fetchNewData = () => {
    dispatchResetMasterDataEmailerListing();
    if (token) {
      let finalData = {
        token,
        searchValue,
        limit,
        offset,
      };
      if (offset === 0) {
        dispatchGetMasterDataEmailers(finalData);
      } else {
        setOffset(0);
      }
    }
  };

  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchValue(value);

    if (value?.length === 0) {
      let finalData = {
        offset: 0,
        limit,
        token,
      };
      dispatchGetMasterDataEmailers(finalData);
    }
  };

  const handleEditMasterEmailer = (data: any) => {
    setIsEdit(true);
    setShowAddEditEmailerModal(true);
    setEmailerName(data?.email_name);
    setSubject(data?.subject);
    setDescription(data?.description);
    setId(data?._id);
    setStatus(data?.status)
  };

  const handleAddEmailer = () => {
    setRefresh(!refresh);
    dispatchResetMasterDataEmailerListing();
    dispatchResetMasterStatusCode();
      if (isEdit) {
        let updateData = {
          token: token,
          email_name: emailerName,
          subject: subject,
          description: description,
          status:status,
          _id: id,
        };
        dispatchUpdateMasterDataEmailers(updateData);
        handleSuccessMessage("update-master-emailer");
      } else {
        let finalAddData = {
          token,
          email_name: emailerName,
          subject: subject,
          description: description,
        };
        dispatchAddMasterEmailers(finalAddData);
        handleSuccessMessage("created-master-emailer");
        setSearchValue("");
      }

    let finalData = {
        token,
        searchValue,
        limit,
        offset,
    };
    if (offset === 0) {
        dispatchGetMasterDataEmailers(finalData);
    } else {
        setOffset(0);
    }
  };

  const handleSuccessMessage = (type: string) => {
    switch (type) {
      case "created-master-emailer":
        return setSuccessMessage("Email entry has been added successfully!");
      case "update-master-emailer":
        return setSuccessMessage("Email data has been updated successfully!");
      default:
        return setSuccessMessage("");
    }
  };

  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < emailListTotalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (emailerList?.length > 0) {
          if (!fetching && offset < emailListTotalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };
  const handleChangeStatus = (data:any) => {
    let finaldata = {
    
    token: token,
    email_name: data?.email_name,
    subject: data?.subject,
    description: data?.description,
    status:!data?.status ,
    _id: data?._id,
    }
   
    dispatchUpdateMasterDataEmailers(finaldata);
    handleSuccessMessage("update-master-emailer");
    let finalData = {
        token,
        searchValue,
        limit,
        offset,
    };
    if (offset === 0) {
        dispatchGetMasterDataEmailers(finalData);
    } else {
        setOffset(0);
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [emailerList]);

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetMasterError();
            }}
          />
        );
      }
    }
    if (success === 1 && message?.includes("added successfully!")) {
      dispatchResetMasterDataEmailerListing();
      dispatchResetMasterSuccess();
      dispatchResetMasterMessage();
      toast.success(successMessage, {
        duration: 2000,
      });
      if (token) {
        let finalData = {
          token,
          limit,
          offset:0,
          searchValue
        };
        if (offset === 0) {
          dispatchGetMasterDataEmailers(finalData);
        }
      }
    }
    if (success === 1 && message?.includes("updated successfully!")) {
      dispatchResetMasterDataEmailerListing();
      dispatchResetMasterSuccess();
      dispatchResetMasterMessage();
      toast.success(successMessage, {
        duration: 2000,
      });
      if (token) {
        let finalData = {
          token,
          limit,
          offset,
          searchValue
        };
        if (offset === 0) {
          dispatchGetMasterDataEmailers(finalData);
        } 
      }
    }

    return false;
  };

  useEffect(() => {
    if (offset === 0) {
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, 0);
      setOffset(0);
    }
  }, [success]);

  return (
    <div className="row">
      <div className="col-md-6">
        <CommonHeader title="Email" />
      </div>
      <div className="col-md-12">
        <div className="jobs-card">
          <div className="header">
            <div className="left-header">
              <div className="heading"> Email List</div>
              {!fetching && (
                <div
                  className="sub-heading"
                  style={{ marginTop: "-22px" }}
                >{`Total ${
                  emailListTotalCount ? emailListTotalCount : 0
                } entries found`}</div>
              )}
            </div>
            <div className="right-header">
              <div
                className={`${
                  !!emailerList?.length ? "col-md-7" : "col-md-10"
                } position-relative`}
              >
                <span
                  style={{ position: "absolute", top: "8px", left: "25px" }}
                >
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search"
                  onChange={(e) => handleSearch(e)}
                  style={{ paddingLeft: "35px" }}
                  value={searchValue}
                />
              </div>
              {!!emailerList?.length &&  isAddEmailPresent &&(
                <button
                  className="btn btn-primary"
                  onClick={toggleAddEditEmailerModal}
                >
                  + Add Email
                </button>
              )}
            </div>
          </div>
          <div>
            {fetching && offset == 0 ? (
              <TableLoader Rows={10} ColumnPerRow={7} />
            ) : emailerList?.length > 0 ? (
              <EmailersTable
                data={data}
                handleEditMasterEmailer={handleEditMasterEmailer}
                handleChangeStatus={handleChangeStatus}
                fetching={fetching}
                offset={offset}
                isUpdateEmailPresent={isUpdateEmailPresent}
              />
            ) : (
              <div className="mt-5 pb-5">
                {!fetching && data?.length === 0 && (
                  <EmptyListPage
                    title="No Email List Found!"
                    image={EmptyList}
                    imageWidth="30%"
                    showAddButton={isAddEmailPresent}
                    buttonTitle="+ Add Email"
                    onButtonClick={toggleAddEditEmailerModal}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {showAddEditEmailerModal && (
        <AddEditEmailers
          showAddEditEmailerModal={showAddEditEmailerModal}
          toggleAddEditEmailerModal={toggleAddEditEmailerModal}
          isEdit={isEdit}
          emailerName={emailerName}
          subject={subject}
          emailerNameError={emailerNameError}
          description={description}
          handleAddEmailer={handleAddEmailer}
          handleEmailerNameChange={handleEmailerNameChange}
          handleSubjectChange={handleSubjectChange}
          handleDescriptionChange={handleDescriptionChange}
        />
      )}
      {handleErrorModal()}
      <Toaster />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.masterData.fetching,
  statusCode: state.masterData.statusCode,
  error: state.masterData.error,
  emailerList: state.masterData.emailerList,
  emailListTotalCount: state.masterData.emailListTotalCount,
  success: state.masterData.success,
  message: state.masterData.message,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchAddMasterEmailers: (data: CreateEmailersDataPayloadType) =>
    dispatch(createMasterEmailersAction(data)),
  dispatchGetMasterDataEmailers: (data: GetEmailerDataPayloadType) => {
    dispatch(getMasterDataEmailersAction(data));
  },
  dispatchUpdateMasterDataEmailers: (data: UpdateEmailerDataPayloadType) => {
    dispatch(updateMasterDataEmailersAction(data));
  },
  dispatchResetMasterSuccess: () => dispatch(resetMasterSuccess()),
  dispatchResetMasterError: () => dispatch(resetMasterError()),
  dispatchResetMasterMessage: () => dispatch(resetMasterMessage()),
  dispatchResetMasterDataEmailerListing: () => dispatch(resetEmailerList()),
  dispatchResetMasterDataEmailerListTotal: () =>
    dispatch(resetEmailListTotalCount()),
  dispatchResetMasterStatusCode: () => dispatch(resetMasterStatusCode()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Email);
